__turbopack_context__.v({
  "feature": "Features-module__ujAtBW__feature",
  "features": "Features-module__ujAtBW__features",
  "wrapper": "Features-module__ujAtBW__wrapper",
});
